import { useScrollReveal } from "../../../hooks/useScrollReveal";
import "./Mechanism02.css";

import RivePlayer from "../../extras/RivePlayer01";

/**
 * @param {{ heading: string; body: string; riveSrc: string }} props
 */
function Mechanism02({ heading, body, riveSrc }) {
  const { ref, isVisible } = useScrollReveal();

  return (
    <div
      ref={ref}
      className={`Mechanism02 section section-reveal ${isVisible ? "section--visible" : ""}`}
      id="Mechanism02"
    >
      <div className="container">
        <div className="Mechanism02-box">
          <RivePlayer src={riveSrc} key={riveSrc} />

          <div className="Mechanism02-text">
            <h2>{heading}</h2>

            <p>{body}</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Mechanism02;
